import { z } from "zod";

import { TOOL_NAMES } from "./toolNames.js";

export const CONFIGURABLE_DISCOVERY_SEARCH_TOOL_NAMES = [
  TOOL_NAMES.SEARCH_KNOWLEDGE,
  TOOL_NAMES.EXPLORE_PROJECTS,
  TOOL_NAMES.SEARCH_GUIDES,
  TOOL_NAMES.FIND_SEMANTIC_COLUMNS,
  TOOL_NAMES.LIST_SEMANTIC_VIEWS,
  TOOL_NAMES.FIND_TABLE_SCHEMAS,
  TOOL_NAMES.DELEGATE_TO_DATA_DISCOVERY_AGENT,
] as const;

export const ConfigurableDiscoveryConfig = z.discriminatedUnion("mode", [
  z.object({
    mode: z.literal("legacy"),
    version: z.literal(0),
  }),
  z.object({
    mode: z.literal("configurable"),
    searchHierarchy: z.array(z.enum(CONFIGURABLE_DISCOVERY_SEARCH_TOOL_NAMES)),
    version: z.literal(0),
  }),
]);
export type ConfigurableDiscoveryConfig = z.infer<
  typeof ConfigurableDiscoveryConfig
>;
export type ConfigurableDiscoverySearchToolName =
  (typeof CONFIGURABLE_DISCOVERY_SEARCH_TOOL_NAMES)[number];

export const DEFAULT_CONFIGURABLE_DISCOVERY_CONFIG: ConfigurableDiscoveryConfig =
  {
    mode: "legacy",
    version: 0,
  };

function dedupeDiscoverySearchHierarchy(
  searchHierarchy: readonly ConfigurableDiscoverySearchToolName[],
): ConfigurableDiscoverySearchToolName[] {
  const seenTools = new Set<ConfigurableDiscoverySearchToolName>();
  return searchHierarchy.filter((toolName) => {
    if (seenTools.has(toolName)) return false;
    seenTools.add(toolName);
    return true;
  });
}

export function parseConfigurableDiscoveryConfig(
  raw: unknown,
  {
    onInvalid,
  }: {
    onInvalid?: (error: z.ZodError) => void;
  } = {},
): ConfigurableDiscoveryConfig {
  const parsed = ConfigurableDiscoveryConfig.safeParse(raw);
  if (!parsed.success) {
    onInvalid?.(parsed.error);
    return DEFAULT_CONFIGURABLE_DISCOVERY_CONFIG;
  }

  if (parsed.data.mode === "legacy") {
    return parsed.data;
  }

  return {
    ...parsed.data,
    searchHierarchy: dedupeDiscoverySearchHierarchy(
      parsed.data.searchHierarchy,
    ),
  };
}
